import { AccountManagerDTO } from 'src/app/core/models/system/account-manager/account-manager.dto';
import { AccountManagersService } from 'src/app/core/services/utelize/system/account-manager/account-managers-service';
import { Component, Input, OnChanges, OnDestroy } from '@angular/core';
import { ExceptionsService } from 'src/app/core/services/utelize/general/exceptions-service';

@Component({
  selector: 'app-account-manager-photo',
  templateUrl: './account-manager-photo.component.html',
  styleUrls: ['./account-manager-photo.component.scss']
})

export class AccountManagerPhotoComponent implements OnChanges, OnDestroy {

  @Input() accountManager: AccountManagerDTO | undefined;
  @Input() size          : number=40;

  public objectUrl: string="";

  constructor(
    private accountManagersService: AccountManagersService,
    private exceptionsService     : ExceptionsService
  ) { }

  public ngOnChanges(): void {
    try {
      this.revoke();

      if (this.accountManager?.hasPhoto && this.accountManager.photoUrl) {
        this.accountManagersService.getPhotoObjectUrl(this.accountManager.photoUrl).subscribe({
          next : url => {
            this.objectUrl=url;
          },
          error: error => {
            this.exceptionsService.handleException(new Error(error));
          }
        });
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public ngOnDestroy(): void {
    try {
      this.revoke();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  get initials(): string {
    try {
      const parts=(this.accountManager?.name ?? "").trim().split(/\s+/).filter(p => p.length > 0);

      if (parts.length==0)
        return "?";

      const first=parts[0].charAt(0);
      const last =parts.length > 1 ? parts[parts.length - 1].charAt(0) : "";

      return (first+last).toUpperCase();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return "?";
    }
  }

  private revoke(): void {
    try {
      if (this.objectUrl.startsWith("blob:"))
        URL.revokeObjectURL(this.objectUrl);

      this.objectUrl="";
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
}
